import { css, html } from 'lit';
import { ariaLabelWithNewTab } from '../../common/utils/a11y-util';
import { customElement, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import store, { waitForUser } from '../../store/store';
import { BaseComponent } from '../../features/base-component/base-component';
import { loading, MessageTemplateId } from '../../common/constants/api-constants';
import {
  getAnalyticsSafeData,
  getUserDataForUserAnalytics,
  selectUser,
} from '../../features/user-profile/user-profile.selectors';
import '../alert/alert';
import { formattedAuthors, HE, isHeStorePurchaseFlow, isHigheredEbook, isNationalFlow, isTunnelPurchaseFlow, numberSuffix } from '../../common/utils/util';
import '../../features/connect-launch/connect-launch-modal';
import { nothing } from 'lit-html';
import { SampleOrderProductInfo } from '../../features/instructor-sample/instructor-sample.interface';
import '../product-card/product-verbiage';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { PaymentOrderItemData, PaymentOrderItemDetails } from './order-completion.interface';
import { UserProfile } from '../user-profile/user-profile.interface';
import { PARAM_ORDER_ID } from '../../common/constants/shop-api';
import { StoreState } from '../../store/store.interface';
import { ActionStatus } from '../../common/constants/action-status';
import {
  appendDurationForTunnelPurchaseFlow,
  appendedDurationForHEProducts,
  calculateDurationDigitalProduct,
  DEFAULT_COVER_IMAGE,
  getImageSrcUrl,
  getPdpLink,
  getProductTitleWithoutEdition,
  getTunnelProductTitleVerbose,
  GO,
  isProfessional,
  isSharpenPlus,
} from '../../common/utils/product-util';
import emit from '../../common/events';
import { PaymentMethodType } from '../payment-methods/payment-method';
import { MessageType } from '../alert/global-message.interface';
import environment, { CheckoutFlow, isGuestCheckoutPage } from '../../common/environment';
import {
  getAccountUrl,
  getBookSelfUrl,
  getCartItemFormat,
  getOrderApplicationForAnalytics,
  toCapCamelCase,
} from '../../common/utils/cart-util';
import './professional/professional-order-confirmation';
import './tunnel/tunnel-order-confirmation';
import { fetchUserProfile } from '../user-profile/user-profile.thunks';
import { getOrder, getOrderItems, getOrderProductMetadata, getOrderStatus, isSampleOrder } from './store/order-completion.selectors';
import OrderConfirmationLogs from './order-confirmation.logs';
import { getOrderData } from './order-completion';
import { isBoardsBeyond, removeCIDBoardsBeyondsFromLocalStorage } from '../firstaid-forward/utils/boards-beyond.util';
import { OrderType } from '../../common/constants/order-types';
import {
  getAdditionalOrderAnalytics,
  getAdditionalSearchTermAnalytics,
  getGuestCheckoutOrderType,
  getPdpTypeInfo,
  getProductTypeInfo,
  getSecondLevelBU,
  getSharpenOrderFlowAnalyticsData,
  getSharpenOrderType,
  getSharpenTunnelFlowProperties,
  PRODUCT_TYPE_FLASHCARD,
  PROFESSIONAL_FCD_TITLE_TYPE,
  removingSearchAnalyticsRelatedLocalStorageObjects,
} from '../../common/utils/analytics-util';
import { SHARPEN_NATIONAL_LAUNCH_URL } from '../upsell/constants/sharpen-page-type.constants';
import { isMhpEbook, isMhpOrder } from '../mhp/utils/mhp.util';
import { OfferTypeChecker } from '../../common/utils/offer-type-util';
import { getAppFlow } from '../user-profile/utils/user-profile.util';
import { getAccessMessage } from '../../common/utils/access-message-util';
import { getSampleProductAuthors } from '../instructor-sample/utils/instructor-sample.util';
import { CoverImageAnalyticsConstants } from '../../common/constants/anayltics.constants';
import { isSharpenUpsellPresentInPaymentOrderDetails } from '../sharpen/utils/sharpen.util';
import { isHeCustomStorePaymentOrder, isHePrivateStorePaymentOrder } from './utils/order-confirmation.util';
import { getCreateCustomImage, getHeStoreContinueShoppingRedirectUrl, getHeStoreDataForAnalytics, renderCreateCustomProductCardMetadata } from '../create-custom/utils/create-custom-product.util';
import "../create-custom/create-custom-product-supplements";
import { SharpenUpsellPromo, SharpenUpsellPromoAnalytics } from '../upsell/interfaces/sharpen-upsell.interface';
import { getSharpenPromoAnalyticsFromOrderCompletion } from '../upsell/sharpen-upsell-promo.analytics';
import { fetchAleksProductTitleVerbose, isAleksSharpenCompanionBundle } from '../../common/utils/aleks-sharpen-bundle-util';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const eBookPurchaseBranding = '30DTSEBKP';
const eBookRentalBranding = '30DTSEBK';
const productSourceCreate = 'CREATE';
const orderId = new URLSearchParams(window.location.search).get(PARAM_ORDER_ID);

/**
 * An element to display the finalized order details on page, post-order completion.
 */
@customElement('mhecomm-order-confirmation')
export class OrderConfirmation extends connect(store)(BaseComponent) {
  static styles = [
    css`
      .product-image img {
        width: 100%;
      }
      .item-list > div:last-child {
        margin-bottom: 0 !important;
      }
    `,
  ];

  /**
   * Flag to indicate component is loading
   */
  @state()
  private isLoading = true;

  /**
   * Whether the user is Higher Ed
   */
  @state()
  private isSeg = false;

  /**
   * First name of user for display
   */
  @state()
  private firstName: string | undefined;

  /**
   * Purchased products
   */
  @state()
  private products: PaymentOrderItemData[] = [];

  /**
   * Type of Purchase ( HE vs SEG )
   */
  @state()
  private requestIdentifier: string | undefined;

  /**
   * Purchased product count
   */
  @state()
  private productCount = 0;

  /**
   * User association
   */
  @state()
  private userSchool = '';

  /**
   * User profile
   */
  @state()
  private user?: UserProfile;

  /**
   * Order Number.
   */
  @state()
  private orderNumber = '';

  /**
   * If truthy, then the order confirmation will not be displayed and an alert will be displayed instead.
   */
  @state()
  private errorMessage = '';

  /**
   * Order Date.
   */
  @state()
  private orderDate = '';

  /**
   * Add error image if image loading have error
   */
  @state()
  private errorImage?: string;

  @state()
  private isPendingOrderConfirmation = false;

  @state()
  private sharpenPdpUrl?: string;

  @state()
  private sharpenUpsellPromo?: SharpenUpsellPromo;

  @state()
  private tunnelProduct?: PaymentOrderItemData;

  @state()
  private _isSampleOrder = false;

  connectedCallback(): void {
    super.connectedCallback();
    store.dispatch(fetchUserProfile());
    const userPromise = waitForUser();

    if (orderId) {
      const orderDataPromise = store.dispatch(getOrderData({ orderId }));
      Promise.all([userPromise, orderDataPromise]).then(() => {
        OrderConfirmationLogs.registerAnalyticsListeners(orderId);
        const orderStatus = getOrderStatus(store.getState() as StoreState);

        userPromise.then(() => OrderConfirmationLogs.loggingUserInformation(orderId));
        OrderConfirmationLogs.loadOrderConfirmation(orderId, orderStatus);

        if (orderStatus !== ActionStatus.succeeded) {
          return;
        }

        OrderConfirmationLogs.beforeEmitOrderConfirmation(orderId);
        if (isSampleOrder(store.getState() as StoreState)) {
          this.emitSampleOrderConfirmation(getOrderItems(store.getState() as StoreState)?.[0]);
        } else {
          this.emitOrderConfirmation(orderId);
        }
        OrderConfirmationLogs.afterEmitOrderConfirmation(orderId);
        removeCIDBoardsBeyondsFromLocalStorage();
      });
    } else {
      waitForUser().then(() => {
        this.user = selectUser(store.getState() as StoreState);
        this.firstName = this.user?.givenName;
        this.isPendingOrderConfirmation = true;
        this.isLoading = false;
      });
    }
  }

  stateChanged(state: StoreState) {
    this.user = selectUser(state);
    this.firstName = this.user?.givenName;
    this.userSchool = this.user?.affiliations[0].orgName;
    this.isSeg = this.user && ['seg'].includes(this.user?.persona?.segment?.toLowerCase());

    if (
      state.orderCompletionState.status === ActionStatus.succeeded &&
      state.orderCompletionState.data?.orderItems &&
      state.orderCompletionState.data?.orderedDate &&
      state.orderCompletionState.data.id
    ) {
      this.isLoading = false;
      this.orderNumber = state.orderCompletionState.data.id;
      this.orderDate = this.renderOrderDate(state.orderCompletionState.data.orderedDate);
      this.products = this.getProducts(state.orderCompletionState.data.orderItems);
      this.tunnelProduct = this.products[0];
      this.requestIdentifier = state.orderCompletionState.data.tokenOrderMetaData?.requestIdentifier;
      this.productCount = this.getProductCount()!;
      this.sharpenPdpUrl = state.orderCompletionState.data.sharpenPdpUrl;
      this.sharpenUpsellPromo = state.orderCompletionState.data.sharpenUpsellPromo;
    } else if (state.orderCompletionState.status === ActionStatus.failed) {
      this.errorMessage = MessageTemplateId.ORDER_CONFIRMATION_LOAD_FAILURE;
    }

    if (
      getOrderStatus(state) === ActionStatus.succeeded &&
      isSampleOrder(state) &&
      !this._isSampleOrder
    ) {
      this._isSampleOrder = true;
    }

    if (this._isSampleOrder) {
      this.isLoading = false;
      this.requestIdentifier = 'he';
      this.productCount = 1;
    }
  }

  getSampleProduct(product: SampleOrderProductInfo): PaymentOrderItemData | undefined {
    return product !== undefined
      ? {
        id: +product.productIdentifier?.isbn10!,
        isbn10: 0,
        isbn: product.productIdentifier?.isbn10,
        isbn13: +product.productIdentifier?.isbn13!,
        mhid: +product.productIdentifier?.mhid!,
        businessUnit: product.productIdentifier?.businessUnit!,
        authors: getSampleProductAuthors(product),
        title: product.title,
        edition:
          product.edition && product.edition > 0
            ? ', ' + product.edition + numberSuffix(+product.edition) + ' Edition'
            : '',
        imageUrl: getImageSrcUrl(product.productIdentifier?.isbn10!),
        virtual: product.itemType === 'VIRTUAL' ? true : false,
        grade: product.gradeLevels,
        quantity: 1,
        unitPrice: product.listPrice,
        url: getPdpLink({
          businessUnit: product.productIdentifier?.businessUnit!,
          isbn: product.productIdentifier?.isbn13!,
        }),
        accessCode: '',
        publishDate: this.renderPublicationDate(product.publicationDate),
        copyrightYear: +product.copyrightYear!,
        isEbook: this.showSampleEbook(product),
        isBookshelf: false,
        expirationDate: undefined,
        expires: false,
        showLaunchButton: this.showSampleLaunchButton(product),
        showAccessCode: false,
        productType: product.format,
      }
      : undefined;
  }

  getProducts(itemDetails: Array<PaymentOrderItemDetails>): Array<PaymentOrderItemData> {
    return itemDetails.map((product) => ({
      id: product.id,
      isbn10: product.isbn10,
      isbn13: product.isbn13,
      mhid: product.mhid,
      businessUnit: product.businessUnit,
      authors: this.renderProductAuthors(product),
      title: product.title,
      edition: this.renderProductTitleEdition(product),
      imageUrl: getImageSrcUrl(OfferTypeChecker.isCreateEbook(product.productMetaData?.offerType) ? product.isbn13.toString() : product.isbn10.toString()),
      virtual: product.virtual,
      grade: product.productMetaData?.grade,
      quantity: product.quantity,
      unitPrice: product.unitPrice,
      countryCode: product.countryCode,
      currencyCode: product?.currencyCode,
      url: getPdpLink({
        businessUnit: product.businessUnit,
        isbn: product.isbn13?.toString(),
        productType: product.productClassifier,
        programSourceName: product.productMetaData?.programSourceName,
        offerType: product.productMetaData?.offerType,
      }),
      accessCode: product.accessCode,
      publishDate: this.renderPublicationDate(product.productMetaData?.publishDate),
      copyrightYear: product.productMetaData?.copyrightYear!,
      isEbook: this.showEbook(product),
      isBookshelf: this.showBookshelf(product),
      expirationDate: this.renderExpirationDate(product),
      expires: this.renderExpiration(product),
      showLaunchButton: this.showLaunchButton(product),
      showAccessCode: this.showAccessCode(product),
      looseLeafAvailable: product.productMetaData?.looseLeafAvailable,
      hasEbook: product.productMetaData?.hasEbook,
      rentalAvailable: product.productMetaData?.rentalAvailable,
      isConnectSharpenBundle: product.productMetaData?.isConnectSharpenBundle,
      isSharpenCompanion: product.productMetaData?.isSharpenCompanion,
      isSharpenAdvantage: product.productMetaData?.isSharpenAdvantage,
      term: product.productMetaData?.term,
      application: product.productMetaData?.application,
      launchObject: product.productMetaData?.launchObject,
      instructions: product?.instructions,
      formatCode: product.productMetaData?.format?.formatCode,
      duration: product.productMetaData?.duration,
      durationPeriod: product.productMetaData?.durationPeriod,
      programSourceId: product.productMetaData?.programSourceId,
      isEvergreen: product.productMetaData?.isEvergreen,
      format: toCapCamelCase(product.productMetaData?.format.formatDescription ?? ''),
      formatTypeDescription: product.productMetaData?.format.formatTypeDescription ?? '',
      offerType: product.productMetaData?.offerType,
      itemType: product.productMetaData?.itemType,
      flow: product.productMetaData?.flow,
      isFreeTrial: product.freeTrialInfo?.isFreeTrial,
      freeTrialEndDate: product.freeTrialInfo?.endDate,
      freeTrialStartDate: product.freeTrialInfo?.startDate,
      freeTrialSubscriptionAmount: product.freeTrialInfo?.subscriptionAmount,
      freeTrialSubscriptionUnitPrice: product.freeTrialInfo?.subscriptionUnitPrice,
      eBookUrls: product.eBookUrls,
      boardsBeyondUrl: product.productMetaData?.boardsBeyondUrl,
      createCoverImages: product.createCustomProductMetadata?.createCoverImages,
      schoolName: product.createCustomProductMetadata?.school?.name,
      department: product.createCustomProductMetadata?.department,
      instructorNames: product.createCustomProductMetadata?.instructorNames,
      courseNumber: product.createCustomProductMetadata?.courses?.[0]?.courseNo,
      supplements: product.createCustomProductMetadata?.supplements,
      metaOfferContentsMetadata: product.productMetaData?.metaOfferContentsMetadata,
    }));
  }

  getOtherProductsInTunnelPurchaseFlow() {
    return this.products.filter((product) => product.id !== this.tunnelProduct?.id);
  }

  getProductsForAnalytics(
    itemDetails: Array<PaymentOrderItemDetails>,
    sharpenPromoOverrides: Partial<SharpenUpsellPromoAnalytics>,
    isSample: boolean,
  ): Array<PaymentOrderItemData> {
    const state = store.getState() as StoreState;

    return itemDetails.map((product) => {
      const item: any = {
        id: product.id,
        isbn10: product.isbn10,
        isbn13: product.isbn13,
        mhid: isSample ? product.isbn10 : product.mhid,
        businessUnit: product.businessUnit,
        authors: this.renderProductAuthors(product),
        title: this.getProductTitleForAnalytics(product),
        edition: this.renderProductTitleEdition(product),
        editionOrRelease: product.productMetaData?.editionOrRelease,
        copyrightYear: product.productMetaData?.copyrightYear!,
        quantity: product.quantity,
        originalPrice: product.originalPrice,
        unitPrice: product.unitPrice,
        offerDiscount: product.offerDiscount,
        productOrdered: product.freeTrialInfo?.isFreeTrial ? 'freetrial' : 'purchasable',
        duration: product.productMetaData?.duration,
        durationPeriod: product.productMetaData?.durationPeriod,
        ...(isProfessional(product.businessUnit ?? '') &&
          product.productMetaData?.titleType !== undefined && {
            titleType: product.productMetaData.titleType,
          }),
        ...(isProfessional(product.businessUnit ?? '') &&
          product.productMetaData?.division !== undefined && {
            division: product.productMetaData.division,
          }),
        publishDate: product.productMetaData?.publishDate,
        productType: this.getProductTypeForAnalytics(product),
        orderType: this.getCartTypeFromOrderCompletion(state),
        durationType: product?.durationType,
        ...getSecondLevelBU({
          programId: product.productMetaData?.programSourceId ?? '',
        }),
        ...getProductTypeInfo({
          programId: product.productMetaData?.programSourceId ?? '',
        }),
        ...getPdpTypeInfo({
          offerType: product.productMetaData?.offerType ?? '',
        }),
        offerPricingId: product.productMetaData?.offerPricingId,
        sku: product.productMetaData?.sku,
        ...getSharpenTunnelFlowProperties({
          isSharpenCompanion: product.productMetaData?.isSharpenCompanion,
          isSharpenAdvantage: product.productMetaData?.isSharpenAdvantage,
          isConnectSharpenBundle: product.productMetaData?.isConnectSharpenBundle,
          itemType: product.productMetaData?.itemType,
          offerType: product.productMetaData?.offerType,
          formatCode: product.productMetaData?.format.formatCode,
          flow: product.productMetaData?.flow,
        }),
        coverImage: this.getCoverImage(product),
        ...sharpenPromoOverrides,
        ...(product.productMetaData?.titleType === PROFESSIONAL_FCD_TITLE_TYPE && {
          productType: PRODUCT_TYPE_FLASHCARD,
        }),
      };

      if (product.businessUnit.toLowerCase() === 'he') {
        item.programSourceId = product.productMetaData?.programSourceId;
        item.programSourceName = product.productMetaData?.programSourceName;
        item.isEvergreenPDP = product.productMetaData?.isEvergreen;
      }

      if (product.freeTrialInfo?.isFreeTrial) {
        item.subscriptionUnitPrice = product.freeTrialInfo.subscriptionUnitPrice;
        item.freeTrialDuration = product.freeTrialInfo.freeTrialDuration;
        item.purchaseOrderNumber = product.freeTrialInfo.purchaseOrderNumber;
      }

      if (isHeStorePurchaseFlow()) {
        Object.assign(item, {
          ...getHeStoreDataForAnalytics({
            isCreateEbook: OfferTypeChecker.isCreateEbook(product.productMetaData?.offerType),
            formatDescription: product.productMetaData?.format?.formatDescription,
            formatTypeDescription: product.productMetaData?.format?.formatTypeDescription,
          }),
        });
      }

      return item;
    });
  }

  getProductTitleForAnalytics(product: PaymentOrderItemDetails) {
    const edition = this.renderProductTitleEdition(product)?.trim() ?? '';
    const duration = isTunnelPurchaseFlow()
    ? appendDurationForTunnelPurchaseFlow({
        duration: product.productMetaData?.duration,
        durationPeriod: product.productMetaData?.durationPeriod,
        term: product.productMetaData?.term,
      })
    : appendedDurationForHEProducts({
      businessUnit: product.businessUnit,
      isVirtual: product.virtual,
      formatTypeDesc: product.productMetaData?.format?.formatTypeDescription!,
      duration: product.productMetaData?.duration!,
      durationPeriod: product.productMetaData?.durationPeriod!,
      ...(product.productMetaData?.offerType && {offerType: product.productMetaData?.offerType}),
    })?.trim() ?? '';
    const title = isTunnelPurchaseFlow() 
      ? (getTunnelProductTitleVerbose((product.title + (edition ? `, ${edition}` : '')), product.productMetaData) + `${duration ? ' ' + duration : ''}`)?.trim()
      : (product.title + (edition ? `, ${edition}${duration ? ' ' + duration : ''}` : duration ? ' ' + duration : ''))?.trim();
    return isAleksSharpenCompanionBundle(product.productMetaData?.offerType, product.productMetaData?.isSharpenCompanion)
      ? fetchAleksProductTitleVerbose(product.productMetaData?.metaOfferContentsMetadata)
      : title;
  }

  getProductTypeForAnalytics(product: PaymentOrderItemDetails) {
    if (product.productMetaData?.titleType === PROFESSIONAL_FCD_TITLE_TYPE) {
      return PRODUCT_TYPE_FLASHCARD;
    }
    return product.productMetaData?.format?.formatDescription;
  }

  getCoverImage(details: PaymentOrderItemDetails): string {
    return (details.businessUnit === HE && OfferTypeChecker.isHeEbook(details.productMetaData?.offerType)) ? CoverImageAnalyticsConstants.NOT_SHOWN : CoverImageAnalyticsConstants.SHOWN;
  }

  getProductCount() {
    return this.products?.map((p) => p.quantity!).reduce((sum, qty) => sum + qty, 0);
  }

  showEbook(details: PaymentOrderItemDetails): boolean {
    return details.virtual && 'he' === details.businessUnit.toLowerCase() && this.testIsEbook(details);
  }

  showBookshelf(details: PaymentOrderItemDetails): boolean {
    return details.virtual && 'he' === details.businessUnit.toLowerCase() && this.testIsBookshelf(details);
  }

  testIsEbook(details: PaymentOrderItemDetails): boolean {
    return eBookRentalBranding === details.branding || eBookPurchaseBranding === details.branding;
  }

  /* it will be only true for he custom stores/bookstores
     which are on shop for now
  */
  testIsBookshelf(details: PaymentOrderItemDetails): boolean {
    return details.productMetaData?.source === productSourceCreate|| OfferTypeChecker.isCreateEbook(details.productMetaData?.offerType);
  }

  showAccessCode(details: PaymentOrderItemDetails): boolean {
    return details.virtual && details.displayCode;
  }

  showLaunchButton(details: PaymentOrderItemDetails): boolean {
    return (
      details.virtual &&
      'he' === details.businessUnit.toLowerCase() &&
      !details.displayCode &&
      'create' !== details.productMetaData?.source?.toLowerCase() &&
      !this.testIsEbook(details)
    );
  }

  renderProductAuthors(details: PaymentOrderItemDetails): string {
    const authors = details?.productMetaData?.contributors?.map((contributor) => contributor.contributorDisplayName).join(', ') || ''
    return formattedAuthors(authors, ', ', ', ', ', ');
  }

  renderProductTitleEdition(details: PaymentOrderItemDetails): string {
    const edition = details.productMetaData?.editionNo;
    return edition && edition > 0 && !details.productMetaData?.isEvergreen && !isSharpenPlus(details.productMetaData?.programSourceId)
      ? edition + numberSuffix(edition) + ' Edition'
      : '';
  }

  isHigherEducationTemplate() {
    return this.requestIdentifier?.toLowerCase() === 'he';
  }

  isProfessionalTemplate() {
    return this.requestIdentifier?.toLowerCase() === 'professional';
  }

  isIndividualRole() {
    return this.user && ['individual'].includes(this.user.persona.role.toLowerCase());
  }

  sampleIsEbook(details: SampleOrderProductInfo): boolean {
    return details.productBrandingCode === eBookRentalBranding || details.productBrandingCode === eBookPurchaseBranding;
  }

  showSampleEbook(details: SampleOrderProductInfo): boolean {
    return (
      'VIRTUAL' === details.itemType &&
      'he' === details.productIdentifier?.businessUnit?.toLowerCase() &&
      this.sampleIsEbook(details)
    );
  }

  showSampleLaunchButton(details: SampleOrderProductInfo): boolean {
    return (
      'VIRTUAL' === details.itemType &&
      'he' === details.productIdentifier?.businessUnit?.toLowerCase() &&
      'connect' === details.format?.toLowerCase()
    );
  }

  renderComp() {
    if (this.errorMessage) {
      return this.errorTemplate();
    } else if (this.isLoading) {
      return this.renderLoadingTemplate();
    } else if (this.isPendingOrderConfirmation) {
      return this.pendingOrderConfirmationTemplate();
    } else if (isTunnelPurchaseFlow()) {
      return this.renderTunnelPurchaseOrder();
    } else if (isMhpOrder(this.products)) {
      return this.renderHigherEdProductList();
    } else if (this.isProfessionalTemplate()) {
      return this.renderProfessionalTemplate();
    } else if (isHeStorePurchaseFlow()) {
      return this.renderHeStorePurchaseOrder();
    } else if (this.isHigherEducationTemplate()) {
      return this.renderHigherEdProductList();
    } else {
      return this.renderK12ProductList();
    }
  }

  renderProfessionalTemplate() {
    return html`
      <mhecomm-order-confirmation-professional orderNumber=${this.orderNumber} .products=${this.products}>
      </mhecomm-order-confirmation-professional>
    `;
  }

  pendingOrderConfirmationTemplate() {
    return html`
      <div>
        <h1 class="mt-4 mb-4">
          Thank you for your order${this.firstName && this.firstName.length > 0 ? ', ' + this.firstName : nothing}!
        </h1>
        <div class="fs-5">
          Your order is being processed. Once that is complete, you will receive an email confirming your details.
        </div>
      </div>
    `;
  }

  emitOrderConfirmation(orderId: string) {
    const accountAge = getOrder(store.getState() as StoreState)?.accountAge;
    const details = this.placeOrderCompleteDetails();
    if (accountAge !== undefined) {
      details.user = {
        ...details.user,
        accountAge,
      };
    }

    OrderConfirmationLogs.emitOrderConfirmation(orderId, details);

    emit({
      element: this,
      name: 'mhecomm-order-confirmation',
      detail: details,
      dataLayer: true,
    });
    // removing CART_PAGE_LOCAL_STORAGE_OBJECT, PDP_PAGE_LOCAL_STORAGE_OBJECT, SEARCH_PAGE_LOCAL_STORAGE_OBJECT and RESET_SEARCH_LOCAL_STORAGE after this step
    removingSearchAnalyticsRelatedLocalStorageObjects();
  }

  emitSampleOrderConfirmation(orderItem?: PaymentOrderItemDetails) {
    const orderFormatTypeDesc = orderItem?.productMetaData?.offerType.toLowerCase();
    let eventName = 'mhecomm-instructor-sampling-confirmation-physical-sample';
    if (orderFormatTypeDesc?.includes('connect')) {
      eventName = 'mhecomm-instructor-sampling-confirmation-connect';
    } else if (orderFormatTypeDesc?.includes('ebook')) {
      eventName = 'mhecomm-instructor-sampling-confirmation-ebook';
    }

    emit({
      element: this,
      name: eventName,
      detail: this.placeOrderCompleteDetails(),
      dataLayer: true,
    });
  }

  placeOrderCompleteDetails() {
    const state = store.getState() as StoreState;
    const sharpenPromoOverrides = state.orderCompletionState.data
      ? getSharpenPromoAnalyticsFromOrderCompletion(state.orderCompletionState.data)
      : {};
    const poNumber = state.orderCompletionState.data?.purchaseOrderNumber;
    const productAnalytics: Array<PaymentOrderItemData> = state.orderCompletionState.data?.orderItems
      ? this.getProductsForAnalytics(
          state.orderCompletionState.data?.orderItems,
          sharpenPromoOverrides,
          this._isSampleOrder,
        )
      : [];

    const productFields = this._isSampleOrder && productAnalytics.length > 0 ? productAnalytics[0] : {};

    const detail: any = {
      id: this.id,
      flow: 'mcgraw',
      promoCode: state.orderCompletionState.data?.promocode,
      totalDiscount: state.orderCompletionState.data?.totalDiscount || '0',
      currencyCode: state.orderCompletionState.data?.currencyCode,
      merchOriginalPriceTotal: state.orderCompletionState.data?.merchOriginalPriceTotal,
      merchPriceTotal: state.orderCompletionState.data?.merchPriceTotal,
      offerDiscountTotal: state.orderCompletionState.data?.offerDiscountTotal,
      totalAmount: state.orderCompletionState.data?.totalAmount,
      freightCharges:
        (parseFloat(state.orderCompletionState.data?.totalFreight || '0') || 0) +
        (parseFloat(state.orderCompletionState.data?.totalHandling || '0') || 0),
      tax: state.orderCompletionState.data?.totalTax,
      paymentType: state.orderCompletionState.data?.paymentGateway
        ? PaymentMethodType.getPaymentMethodFromOrderPaymentType(state.orderCompletionState.data?.paymentGateway)
          ?.displayName
        : '',
      serviceFee: state.orderCompletionState.data?.digitalHandlingFees ?? '0',
      orderId: state.orderCompletionState.data?.id,
      orderType: this.getCartTypeFromOrderCompletion(state),
      url: window.location.href,
      user: getUserDataForUserAnalytics(store.getState() as StoreState, true, isNationalFlow()), //add on sampling too
      ...getAdditionalOrderAnalytics({
        programIds:
          state.orderCompletionState.data?.orderItems?.map(
            (product) => product.productMetaData?.programSourceId ?? ''
          ) ?? [],
      }),
      ...getAdditionalSearchTermAnalytics({
        captureProceedToCheckoutAnalytics: true,
      }),
      isEdoms: !!state.orderCompletionState.data?.metaOfferId,
      ...(!!poNumber && 
      { 
        paymentType: "Purchase Order", 
        purchaseOrderNumber: poNumber 
      }), 
      ...sharpenPromoOverrides,
      ...(!this._isSampleOrder && { products: productAnalytics }),
      ...(this._isSampleOrder && productFields),
    };

    if (isTunnelPurchaseFlow()) {
      const orderProductMetadata = getOrderProductMetadata(state);
      const isSharpenPlusUpsellPresent =
        state.orderCompletionState.data && isSharpenUpsellPresentInPaymentOrderDetails(state.orderCompletionState.data);
      Object.assign(detail, {
        flow: 'tunnel-purchase',
        application: getOrderApplicationForAnalytics(orderProductMetadata),
        ...(this.tunnelProduct?.countryCode && {countryCode: this.tunnelProduct.countryCode}),
        ...(this.tunnelProduct?.currencyCode && {currencyCode: this.tunnelProduct.currencyCode}),
        ...(isSharpenPlusUpsellPresent && getSharpenOrderFlowAnalyticsData()),
      });
    }

    return detail;
  }
  errorTemplate() {
    return html` <mhecomm-alert type=${MessageType.warning} message=${this.errorMessage}></mhecomm-alert> `;
  }

  getCartTypeFromOrderCompletion(state: StoreState) {
    const orderCompletion = state.orderCompletionState.data;
    const productMetadata = getOrderProductMetadata(state);
    if (isTunnelPurchaseFlow()) {
      return getSharpenOrderType({
        offerType: productMetadata.offerType,
        itemType: productMetadata.itemType,
        flow: productMetadata.flow,
        application: productMetadata.application,
        formatCode: productMetadata.format.formatCode,
        isConnectSharpenBundle: productMetadata.isConnectSharpenBundle,
        isSharpenCompanion: productMetadata.isSharpenCompanion,
        isSharpenAdvantage: productMetadata.isSharpenAdvantage,
      });
    } else if (isGuestCheckoutPage()) {
      return getGuestCheckoutOrderType(productMetadata.application);
    } else if (isHePrivateStorePaymentOrder(orderCompletion)) {
      return OrderType.HE_CUSTOM_STORE;
    } else if (isHeCustomStorePaymentOrder(orderCompletion)) {
      return OrderType.HE_CREATE;
    } else if (orderCompletion?.storeCode && orderCompletion?.storeCode.toLowerCase().includes('k12 custom stores')) {
      return OrderType.K12_STOREFRONT;
    } else if (orderCompletion?.tokenOrderMetaData?.requestIdentifier === 'PROFESSIONAL') {
      if (isBoardsBeyond()) {
        return OrderType.BOARDS_AND_BEYOND_ORDER_TYPE;
      }
      return OrderType.PROFESSIONAL;
    } else if (orderCompletion?.tokenOrderMetaData?.requestIdentifier === 'HE') {
      return OrderType.HE_NATIONAL;
    } else if (orderCompletion?.tokenOrderMetaData?.requestIdentifier === 'SEG') {
      return OrderType.SEG_NATIONAL;
    } else {
      return '';
    }
  }

  renderTunnelPurchaseOrder() {
    return html`
      <mhecomm-tunnel-order-confirmation
        orderNumber=${this.orderNumber}
        .sharpenUpsellPromo=${this.sharpenUpsellPromo}
        .tunnelProduct=${this.tunnelProduct!}
        .upsellProducts=${this.getOtherProductsInTunnelPurchaseFlow()}
      >
      </mhecomm-tunnel-order-confirmation>
    `;
  }

  renderK12ProductList() {
    return html`
      <div>
        <h1 class="mt-4 mb-4">
          Thank you for your order${this.firstName && this.firstName.length > 0 ? ', ' + this.firstName : nothing}!
        </h1>
        <div>Your order has been processed.</div>
        <div class="mb-3">
          You will receive an email summarizing your purchase shortly. If you do not receive an email within 5 minutes,
          please check your junk and spam folders.
        </div>
        <div class="border rounded p-3">
          <div class="fw-semibold fs-large" data-automation-id="order-number">Order Number: ${this.orderNumber}</div>
          <div class="fw-semibold fs-large">Order Date: ${this.orderDate}</div>
          <div class="fw-semibold fs-large">School: ${this.userSchool}</div>

          <div class="item-list mt-4">
            ${this.products.map(
      (product) => html`
                <div class="mb-3">
                  <div class="fw-semibold">${product.title}${product.edition ? `, ${product.edition}` : ''}</div>
                  <div>
                    <span class="fw-bold">${product.businessUnit == 'SEG' ? 'MHID' : 'ISBN10'}:</span>
                    ${product.businessUnit == 'SEG' ? product.mhid : product.isbn10} /
                    <span class="fw-bold">ISBN13:</span> ${product.isbn13}
                  </div>
                  <div><span class="fw-bold">Quantity:</span> ${product.quantity}</div>
                </div>
              `
    )}
          </div>
        </div>

        <ul class="mt-4 mb-4">
          ${this.isSeg && !this.isIndividualRole()
        ? html`
                <li>
                  If you purchased teacher-only or restricted products for the first time,
                  <a
                    tabindex="0"
                    href="javascript:void(0)"
                    role="button"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-trigger="focus"
                    data-bs-placement="top"
                    data-bs-content="If you are a teacher or homeschooler ordering restricted materials for the first time, please email a copy of your teaching certificate to <a href='mailto:mhe_cust_service@mheducation.com'>mhe_cust_service@mheducation.com</a>. If you are an Admin/Teacher ordering restricted material for the first time, please email a copy of your tax exemption, website for the school, or school letterhead that lists the address of the school to <a href='mailto:mhe_cust_service@mheducation.com'>mhe_cust_service@mheducation.com</a>."
                    >please click here to help us process your order as quickly as possible</a
                  >.
                </li>
              `
        : ``}
          <li>If you order includes digital materials, you will receive a welcome email within 5 business days.</li>
          <li>
            If you order includes print materials, they will be shipped to you. Visit your
            <a href="${getAccountUrl()}" @click=${(e: Event) => this.onClickAccountPageLink(e)}>account page</a> to track your shipment.
          </li>
        </ul>
        <div>Any questions, please contact our customer service team at 1-800-338-3987.</div>
        ${this.isSeg && !this.isIndividualRole()
        ? html`
              <div class="mb-3">
                Do you need information about
                <a
                  tabindex="0"
                  href="javascript:void(0)"
                  data-bs-toggle="popover"
                  data-bs-html="true"
                  data-bs-trigger="focus"
                  data-bs-placement="top"
                  data-bs-content="Tax exempt? All orders initially display tax. As long as your billing address is your organization's address and you have previously sent your tax information, you will not be charged tax. (A good indicator would be if you were exempt on a previous order with the same billing address.)"
                  >tax exemption</a
                >?
              </div>
            `
        : ``}
        <div>Thank you for shopping with us,</div>
        <div class="fw-semibold">Your McGraw Hill Team</div>
        <div class="mb-4 mt-4">
          * If you do not receive a confirmation email within 5 minutes, please check your junk or spam folder. If the
          problem persists, visit your
          <a href="${getAccountUrl()}" @click=${(e: Event) => this.onClickAccountPageLink(e)}>account page</a> to check your email address and order history.
        </div>
      </div>
    `;
  }

  renderHELaunchButton(product: PaymentOrderItemData) {
    if (product.showLaunchButton && isSharpenPlus(product.programSourceId)) {
      return html` <button
        type="button"
        class="btn btn-primary btn-lg mt-4 mb-2 w-100 w-md-auto"
        @click=${this.gotosharpen}
        aria-label="Opens sharpen in new window"
        id="gotosharpen"
      >
        Launch
      </button>`;
    }
    if (product.showLaunchButton && this._isSampleOrder) {
      return html` <button
        type="button"
        class="btn btn-primary btn-lg mt-4 mb-2"
        @click=${this.gotoconnect}
        aria-label="Opens connect in new window"
        id="gotoconnect"
      >
        Login to Connect
      </button>`;
    }
    if (this.isGoProduct(product)) {
      return html` <div>
        ${getAccessMessage(GO)}
      </div>`;
    }
    if (product.showLaunchButton) {
      return html`
        <mhecomm-connect-launch-modal
          class="d-block mt-2"
          .triggerAriaLabel=${'Launch Connect'}
          isbn=${product.isbn10}
          orderId=${orderId!}
          .connectLaunchUrl=${product.launchObject?.url}
          @opened-modal=${() => this.fireAnalytics(`btn-launch-${orderId}-${product.isbn10}`, 'Launch Connect', 'launch-connect')}
        >
        </mhecomm-connect-launch-modal>`;
    }
    return nothing;
  }

  renderSharpenPlusProductDetails(product: PaymentOrderItemData) {
    return html`
      <div class="col-9 ps-4 position-relative">
        <div>
          <a class="fs-large fw-semibold text-decoration-none" href="${product.url || ''}" @click=${() => this._triggerCTAAnalyticsData('click-product-title-order-confirmation', product.title!, product, product.url)}>
            ${getProductTitleWithoutEdition({
              title: product.title,
              programSourceId: product?.programSourceId!,
              businessUnit: product.businessUnit,
              isVirtual: product.virtual ? true : false,
              formatTypeDesc: product?.formatTypeDescription!,
              duration: product?.duration!,
              durationPeriod: product?.durationPeriod!,
              ...(product?.offerType && {offerType: product?.offerType}),
            })}
          </a>
        </div>
        <div class="mt-2">
          <span class="fw-bold">Format:</span>
          ${getCartItemFormat(product.format, product.formatCode ?? '', true)}
        </div>
        <div class="mt-2 mb-6"><span class="fw-bold">Access Through:</span> ${product.expirationDate}</div>
        <div class="d-none d-md-block">
          ${this.renderHELaunchButton(product)}
        </div>
      </div>
      <div class="col-12 d-md-none">
        ${this.renderHELaunchButton(product)}
      </div>
    `;
  }

  renderHigherEdProductList() {
    return html`
      <div>
        ${isTunnelPurchaseFlow() && this.sharpenPdpUrl
        ? html` <a href="${this.sharpenPdpUrl}" target="_blank">
              <img
                src="/content/dam/mhe/sharpen/banner/sharpen-order-confirmation-desktop-banner.png"
                class="img-fluid d-none d-sm-block"
                alt=""
              />
              <img
                src="/content/dam/mhe/sharpen/banner/sharpen-order-confirmation-mobile-banner.png"
                class="img-fluid d-block d-sm-none"
                alt=""
              />
            </a>`
        : nothing}
        <h1 class="mt-4 mb-4">
          Thank you for your order${this.firstName && this.firstName.length > 0 ? ', ' + this.firstName : nothing}!
        </h1>
        <div class="fs-5">
          Your order has been processed. Your order number is:
          <span class="fw-bold" data-automation-id="order-number">${this.orderNumber}</span>.
        </div>
        <div>
          You will receive an email summarizing your purchase shortly. If you do not receive an email within 5 minutes,
          please check your junk and spam folders. If the problem persists, you may have entered your email address
          incorrectly. Visit your <a href="${getAccountUrl()}" @click=${(e: Event) => this.onClickAccountPageLink(e)}>account page</a> to check your email address, order
          history and access codes.
        </div>
        <div>You have purchased ${this.productCount} item${this.productCount > 1 ? 's' : ''}.</div>
        <div class="item-list mt-5">
          ${this.products != undefined && this.products.map((product) => this.renderHeProductDetails(product))}
          ${this._isSampleOrder
        ? html`
                <a
                  href="${environment().mheducationUrl}/highered/support.html"
                  class="btn btn-outline-primary btn-lg mt-4 mb-2"
                  @click=${this.onClickInstructorSupportLink}
                  id="view-instructor-support-link"
                >
                  View Instructor Support
                </a>
              `
        : nothing}
        </div>
      </div>
    `;
  }

  renderHeProductDetails(product: PaymentOrderItemData) {
    return html`
      <div class="small-card d-flex flex-wrap mb-4">
        ${product?.imageUrl && !isHigheredEbook(product)
        ? html` <div class="product-image col-3 col-lg-2 pe-4">
              <img
                src="${this.errorImage ? this.errorImage : product.imageUrl! || ''}"
                @error=${() => this.loadDefaultImage()}
                alt=""
              />
            </div>`
        : nothing}
        ${isSharpenPlus(product?.programSourceId)
        ? this.renderSharpenPlusProductDetails(product)
        : html`
              <div class="col-9 position-relative">
                <div>
                  <a class="fs-large fw-semibold text-decoration-none" href="${product.url || ''}" @click=${() => this._triggerCTAAnalyticsData('click-product-title-order-confirmation', product.title!, product, product.url)}>
                    ${product.title}
                    ${product.edition
                      ? html`<span class="fw-normal text-nowrap">, ${product.edition}</span>`
                      : nothing
                    }
                    ${appendedDurationForHEProducts({
                        businessUnit: product.businessUnit,
                        isVirtual: product.virtual ? true : false,
                        formatTypeDesc: product?.formatTypeDescription!,
                        duration: product?.duration!,
                        durationPeriod: product?.durationPeriod!,
                        ...(product?.offerType && {offerType: product?.offerType}),
                      })
                    }
                  </a>
                </div>
                ${this._isSampleOrder
            ? html` <div>
                      <span class="fw-bold">ISBN10:</span> ${product.isbn10} /
                      <span class="fw-bold">ISBN13:</span> ${product.isbn13}
                    </div>`
            : html`
                      <div>
                        <span class="fw-bold">${product.businessUnit == 'SEG' ? 'MHID' : 'ISBN10'}:</span>
                        ${product.businessUnit == 'SEG' ? product.mhid : product.isbn10} /
                        <span class="fw-bold">ISBN13:</span> ${product.isbn13}
                      </div>
                    `}
                ${product.authors ? html` <div><span class="fw-bold">By:</span> ${product.authors}</div>` : ``}
                ${product.copyrightYear && product.copyrightYear > 0 && !product.isEvergreen
            ? html` <div>&copy; ${product.copyrightYear}</div>`
            : nothing}
                ${product.productType
            ? html` <div>
                      <span class="fw-bold">Format:</span>
                    </div>`
            : ``}
                ${!product.isBookshelf && isSharpenPlus(product.programSourceId)
            ? html` <div><span class="fw-bold">Publication Date:</span> ${product.publishDate}</div>`
            : ``}
                ${product.isEbook
            ? html` <div class="mt-2 mb-2">
                      <a
                        class="btn btn-primary"
                        href="${getBookSelfUrl()}"
                        target="_blank"
                        aria-label="${ariaLabelWithNewTab('Access My eBook')}"
                        @click="${this.emitAccessMyebook}"
                        >Access My eBook</a
                      >
                    </div>`
            : ``}
                ${product.isBookshelf
            ? html` <div class="mt-2 mb-2">
                      <a class="btn btn-primary" href="${getBookSelfUrl()}" target="_blank" aria-label="${ariaLabelWithNewTab('Access My Bookshelf')}"
                        >Access My Bookshelf</a
                      >
                    </div>`
            : ``}
                ${this.renderHELaunchButton(product)}
                ${product.expires ? html` <div class="mt-2 mb-2"><span class="fw-bold">Expires:</span> ${product.expirationDate}</div>` : ``}
                ${product.isEbook
            ? html` <div class="mt-2 mb-2">
                      Click "<span class="fw-semibold">Access My eBook</span>" or go to
                      <a
                        href="${getBookSelfUrl()}"
                        target="_blank"
                        class="fw-semibold"
                        aria-label="${ariaLabelWithNewTab('myebooks.meducation.com')}"
                        @click="${this.emitAccessMyebook}"
                        >myebooks.meducation.com</a
                      >
                      to access your eBook.
                    </div>`
            : ``}
                ${product.showAccessCode
            ? html` <div class="fw-bold mt-2 mb-2">Your Access Code:<br />${product.accessCode}</div>`
            : ``}
                ${product.instructions
            ? html` <div class="fw-bold mt-2 mb-2">${unsafeHTML(product.instructions)}</div>`
            : ``}
                ${!product.virtual
            ? html` <div class="mt-2">
                      <span class="badge bg-light text-dark text-wrap"
                        >This product will be shipped to you. Visit your account page to track your shipment.</span
                      >
                    </div>`
            : ``}
                ${isMhpEbook(product)
            ? html` <div class="mt-4">
                      <mhecomm-mhp-ebook-download
                        .eBookUrls="${product.eBookUrls}"
                        isbn="${product.isbn10}"
                      ></mhecomm-mhp-ebook-download>
                    </div>`
            : nothing}
              </div>
            `}
      </div>
      ${product.isBookshelf
        ? html` <div class="mb-3">
            <div class="fw-bold fs-5">Download Your eBook</div>
            To download, you must first access your eBook online by clicking on the "Access My Bookshelf" button and
            directions on the screen. Then, if you already have the Vitalsource Bookshelf App, open it and sync your
            eBook. If not, download the App from
            <a
              href="https://support.vitalsource.com/hc/en-us/articles/201344733-Bookshelf-Download-Options"
              target="_blank"
              aria-label="${ariaLabelWithNewTab('Vitalsource Download Center')}"
              >Vitalsource Download Center</a
            >, and sync to access your offline eBook. You will need your Vitalsource password and may have to reset it
            from the desktop bookshelf. If you need help,
            <a href="https://support.vitalsource.com/hc/en-us" target="_blank"
              aria-label="${ariaLabelWithNewTab('Go to VitalSource support page')}"
              >go here</a
            >.
          </div>`
        : ``}
    `;
  }

  renderHeStorePurchaseOrder() {
    const redirectUrl = getHeStoreContinueShoppingRedirectUrl(this.products);

    return html`
      <div class="container p-0">
        <div class="conatiner py-0 px-4 mb-3">
          <h1 class="fw-bold">
            Thank you for your order${this.firstName && this.firstName.length > 0 ? ', ' + this.firstName : nothing}!
          </h1>
          <div class="fs-6 p-0 pt-2">
            Your order has been processed.
          </div>
          <div class="fs-6 p-0 pt-2">
            <strong>Order Number</strong> <span data-automation-id="order-number">${this.orderNumber}</span>
          </div>
          <div class="fs-6 p-0 pt-2">
            You will receive a confirmation email shortly. Please keep it for your records.*
          </div>
        </div>
        <div class="item-list container p-0 mb-3">
          ${this.products.map(
            (product) => {
              return html`
                <div class="card p-4 pt-3 border-0">
                  <div class="row g-0">
                    <!-- Left Col image -->
                    <div class="col-2 pe-4">
                      ${this.createCustomImage(product, true)}
                    </div>

                    <!-- Right Col metadata -->
                    <div class="col-10 pb-5">
                      <div class="pb-3">
                        <a class="fs-large fw-semibold text-decoration-none" href="${product.url || ''}" @click=${() => this._triggerCTAAnalyticsData('click-product-title-order-confirmation', product.title!, product, product.url)}>
                          ${product.edition
                            ? html`${product.title?.trim()},<span class="fw-normal text-nowrap"> ${product.edition}</span>`
                            : html`${product.title?.trim()}`
                          }
                          ${appendedDurationForHEProducts({
                              businessUnit: product.businessUnit,
                              isVirtual: product?.virtual || false,
                              formatTypeDesc: product?.formatTypeDescription || '',
                              duration: product?.duration ?? 0,
                              durationPeriod: product?.durationPeriod || '',
                              ...(product?.offerType && {offerType: product?.offerType}),
                            })
                          }
                        </a>
                      </div>
                      ${product.isBookshelf
                        ? html`
                          <div class="mb-3">
                            <a
                              class="btn btn-primary"
                              href="${getBookSelfUrl()}"
                              target="_blank"
                              aria-label="${ariaLabelWithNewTab('Access My Bookshelf')}"
                              @click=${() => this._triggerCTAAnalyticsData('access-my-bookshelf', 'Access My Bookshelf', product, getBookSelfUrl())}
                            >
                              Access My Bookshelf</a
                            >
                          </div>`
                        : ``
                      }
                      ${renderCreateCustomProductCardMetadata({
                        isCreateEbook: OfferTypeChecker.isCreateEbook(product?.offerType),
                        product,
                        copyrightYear: product.copyrightYear?.toString(),
                        showProductType: false,
                        parsedAuthor: true,
                      })}
                    </div>
                  </div>
                  <mhecomm-create-custom-product-supplements
                    .supplements="${product?.supplements}"
                    headerLevel="h4">
                  </mhecomm-create-custom-product-supplements>
                </div>
              `
            }
          )}
        </div>
        <div class="container px-4 pb-3 mb-3">
          <span>
            *Check your spam or junk mail folder If you do not receive your confirmation email within five minutes.
          </span>
        </div>
        <div class="container px-4">
          <div class="col-2">
            <mhecomm-continue-shopping
              labelname="Continue Shopping"
              btnClass="btn btn-secondary"
              .store=${CheckoutFlow.hestores}
              .redirectUrl=${redirectUrl}
            ></mhecomm-continue-shopping>
          </div>
        </div>
      </div>
    `
  }

  createCustomImage(
    product: PaymentOrderItemData,
    isCreateEbook: boolean,
  ) {
    return getCreateCustomImage({
      altText: product.title,
      createCoverImages: product.createCoverImages,
      identifier: product.isbn13.toString() || '',
      image: product?.imageUrl,
      isCreateEbook,
    });
  }

  _triggerCTAAnalyticsData(name: string, label: string, product: PaymentOrderItemData, href?: string) {
    const orderDetail: any = {
      orderNumber: this.orderNumber,
      user: getAnalyticsSafeData(this.user!),
      buttonName: label,
      isbn13: product.isbn13,
      mhid: product?.mhid,
      itemType: product?.itemType,
      ...(href && { href: href }),
    };
  
    if (product.businessUnit?.toLowerCase() === 'he') {
      orderDetail.businessUnit = product.businessUnit;
      orderDetail.programSourceId = product?.programSourceId;
      orderDetail.programSourceName = product?.programSourceName;
      orderDetail.isEvergreenPDP = product?.isEvergreen;
    }
  
    emit({
      element: this,
      name,
      detail: JSON.parse(JSON.stringify(orderDetail)),
    });
  }

  isGoProduct(product: PaymentOrderItemData) {
    return OfferTypeChecker.isGo(product.offerType);
  }

  renderLoadingTemplate() {
    return html`
      <span class="visually-hidden">Loading order confirmation</span>
      ${loading({ width: '25%', height: '3rem', m: 'my-4' })} ${loading({ width: '55%' })} ${loading({ width: '35%' })}
      ${loading({ width: '55%' })} ${loading({ width: '30%' })} ${loading({ width: '45%' })}
      ${loading({ width: '65%' })} ${loading({ width: '50%', m: 'mb-4' })}
    `;
  }

  /**
   * Emits an event when the launch connect button is clicked.
   *
   * @param id
   * @param label
   * @param name
   */
  private fireAnalytics(
    id: string,
    label: string,
    name: string
  ) {
    emit({
      element: this,
      name: 'click',
      detail: {
        id,
        label,
        comp: 'button',
        eventName: `open-${name}`,
        user: getAnalyticsSafeData(this.user!),
        appFlow: getAppFlow()
      },
      dataLayer: true
    });
  }

  private renderOrderDate(orderDate: string) {
    const d = new Date(orderDate);

    const year = d.getFullYear();
    const monthName = months[d.getMonth()];
    const dayName = days[d.getDay()];
    const monthDate = d.getDate();
    const time = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

    return `${dayName}, ${monthName} ${monthDate} ${time} ${year}`;
  }

  private renderPublicationDate(epochDateString) {
    const d = new Date(epochDateString);

    const year = d.getUTCFullYear();
    const monthName = months[d.getUTCMonth()];
    const monthDate = d.getUTCDate();

    return `${monthName} ${monthDate}, ${year}`;
  }

  renderExpirationDate(details: PaymentOrderItemDetails): string {
    const order = getOrder(store.getState() as StoreState);
    if (details.productMetaData?.duration) {
      const { duration, durationPeriod } = details.productMetaData;
      return calculateDurationDigitalProduct(duration, durationPeriod, order?.orderedDate).toLocaleDateString('en-US');
    }

    if (details.licenseEndDate) {
      const newDate = new Date(details.licenseEndDate);

      const year = newDate.getUTCFullYear();
      const month = newDate.getUTCMonth() + 1;
      const monthDate = newDate.getUTCDate();

      return `${month}/${monthDate}/${year}`;
    }

    return '';
  }

  renderExpiration(details: PaymentOrderItemDetails): boolean {
    return (
      (details.licenseEndDate || details.productMetaData?.duration ? true : false) &&
      !OfferTypeChecker.isGdp(details.productMetaData?.offerType)
    );
  }

  updated() {
    this.bsInit('[data-bs-toggle="popover"]', window.bootstrap?.Popover, { trigger: 'focus' });
  }

  loadDefaultImage() {
    this.errorImage = DEFAULT_COVER_IMAGE;
  }

  public redirectToHome() {
    emit({
      element: this,
      name: 'mhecomm-continue-browsing',
      dataLayer: true,
      detail: { id: this.id },
    });

    window.location.href = environment().mheducationUrl;
  }

  public onClickAccountPageLink(event: Event): void {
    const link = event.currentTarget as HTMLAnchorElement;

    emit({
      element: link,
      name: 'click-account-page-order-confirmation',
      detail: {
        label: 'Account Page',
        href: link.href,
        orderNumber: this.orderNumber,
        orderType: this.getCartTypeFromOrderCompletion(store.getState() as StoreState),
        user: getAnalyticsSafeData(this.user!),
      },
    });
  }

  public onClickInstructorSupportLink(): void {
    emit({
      element: this,
      name: 'mhecomm-view-instructor-support',
      dataLayer: true,
      detail: { id: this.id },
    });
  }

  public emitAccessMyebook() {
    emit({
      element: this,
      name: 'mhecomm-access-ebook',
      dataLayer: true,
      detail: { id: this.id },
    });
  }

  public gotoconnect() {
    emit({
      element: this,
      name: 'mhecomm-go-to-connect',
      dataLayer: true,
      detail: { id: this.id },
    });
    window.open(environment().connectUrl);
  }

  public gotosharpen() {
    emit({
      element: this,
      name: 'mhecomm-go-to-sharpen',
      dataLayer: true,
      detail: { id: this.id },
    });
    window.open(SHARPEN_NATIONAL_LAUNCH_URL);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-order-confirmation': OrderConfirmation;
  }
}